import WarehouseService from '../services/warehouse.service';
// import moment from 'moment';

export const warehouse = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {

    getAllWarehouses({ commit }) {
      return WarehouseService.getAllWarehouses().then(
        resp => {
          commit('dummyConsole', "getAllWarehouses - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "getAllWarehouses - error");
          return Promise.reject(error);
        }
      );
    },

    //#region Advance
    getAdvance({ commit }, warehouseLenderId) {
      return WarehouseService.getAdvance(warehouseLenderId).then(
        resp => {
          commit('dummyConsole', "getAdvance - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "getAdvance - error");
          return Promise.reject(error);
        }
      );
    },

    createAdvance({ commit }, jnl) {
      return WarehouseService.createAdvance(jnl).then(
        resp => {
          commit('dummyConsole', "createAdvance - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "createAdvance - error");
          return Promise.reject(error);
        }
      );
    },

    updateAdvance({ commit }, { jnlId, updateJnl }) {
      console.log('module updateAdvance,', {jnlId, updateJnl})

      return WarehouseService.updateAdvance(jnlId, updateJnl).then(
        resp => {
          commit('dummyConsole', "updateAdvance - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "updateAdvance - error");
          return Promise.reject(error);
        }
      );
    },

    deleteAdvance({ commit }, jnlId) {
      return WarehouseService.deleteAdvance(jnlId).then(
        resp => {
          commit('dummyConsole', "deleteAdvance - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "deleteAdvance - error");
          return Promise.reject(error);
        }
      );
    },
    //#endregion

    //#region Fee
    getFee({ commit }, warehouseLenderId) {
      return WarehouseService.getFee(warehouseLenderId).then(
        resp => {
          commit('dummyConsole', "getFee - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "getFee - error");
          return Promise.reject(error);
        }
      );
    },

    createFee({ commit }, jnl) {
      return WarehouseService.createFee(jnl).then(
        resp => {
          commit('dummyConsole', "createFee - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "createFee - error");
          return Promise.reject(error);
        }
      );
    },

    updateFee({ commit }, {jnlId, updateJnl}) {
      console.log('module jnlId,', {jnlId, updateJnl})
      return WarehouseService.updateFee(jnlId, updateJnl).then(
        resp => {
          commit('dummyConsole', "updateFee - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "updateFee - error");
          return Promise.reject(error);
        }
      );
    },

    deleteFee({ commit }, jnlId) {
      return WarehouseService.deleteFee(jnlId).then(
        resp => {
          commit('dummyConsole', "deleteFee - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "deleteFee - error");
          return Promise.reject(error);
        }
      );
    },    
    //#endregion

    //#region IntRate
    getIntRate({ commit }, warehouseLenderId) {
      return WarehouseService.getIntRate(warehouseLenderId).then(
        resp => {
          commit('dummyConsole', "getIntRate - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "getIntRate - error");
          return Promise.reject(error);
        }
      );
    },

    createIntRate({ commit }, jnl) {
      return WarehouseService.createIntRate(jnl).then(
        resp => {
          commit('dummyConsole', "createIntRate - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "createIntRate - error");
          return Promise.reject(error);
        }
      );
    },

    updateIntRate({ commit }, { jnlId, updateJnl }) {
      return WarehouseService.updateIntRate(jnlId, updateJnl).then(
        resp => {
          commit('dummyConsole', "updateIntRate - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "updateIntRate - error");
          return Promise.reject(error);
        }
      );
    },

    deleteIntRate({ commit }, jnlId) {
      return WarehouseService.deleteIntRate(jnlId).then(
        resp => {
          commit('dummyConsole', "deleteIntRate - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "deleteIntRate - error");
          return Promise.reject(error);
        }
      );
    },
    //#endregion

    getAdvanceInformation({ commit }, {fileName, loanPurchaseDate}) {
      console.log({fileName, loanPurchaseDate})
      return WarehouseService.getAdvanceInformation(fileName, loanPurchaseDate).then(
        resp => {
          commit('dummyConsole', "getAdvanceInformation - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "getAdvanceInformation - error");
          return Promise.reject(error);
        }
      );
    },

    setLoanPurchaseDate({ commit }, {fileName, setData}) {
      return WarehouseService.setLoanPurchaseDate(fileName, setData).then(
        resp => {
          commit('dummyConsole', "setLoanPurchaseDate - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummyConsole', "setLoanPurchaseDate - error");
          return Promise.reject(error);
        }
      );
    },    

  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    }
  }
};